import React from 'react';
import './ConfirmPolicies.scss';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../../Router';

const baseHeaders = [
    { header: 'N° cuota' },
    { header: 'Fecha de pago' },
    { header: 'Cuota' },
    { header: 'Intereses' },
    { header: 'Abono capital' },
    { header: 'Saldo' },
];
type Cuota = {
    n_num_cuo: string;
    f_fecha: string;
    n_sal_ini: string;
    n_capital: string;
    n_int_1: string;
    n_int_2: string;
    n_int_3: string;
    n_int_4: string;
    n_int_5: string;
    n_int_6: string;
    n_int_7: string;
    n_int_8: string;
    n_int_9: string;
    n_int_10: string;
    n_cap_tf: string;
    n_int_tf: string;
    n_total: string;
    n_sal_fin: string;
    n_intnom_1: string;
    n_intnom_2: string;
    n_intnom_3: string;
    n_intnom_4: string;
    n_intnom_5: string;
    n_intnom_6: string;
    n_intnom_7: string;
    n_intnom_8: string;
    n_intnom_9: string;
    n_intnom_10: string;
};
type ConfirmPoliciesProps = {
    cuotas: Cuota[];
    valorCuota: string;
};

export const ModalConfirmPolicies: React.FC<ConfirmPoliciesProps> = ({cuotas, valorCuota}) => {
    const navigate = useNavigate();


    const finalizar=()=>{
        navigate(AppRoutes.THANKYOU, {replace: true});
    }

    const aceptar=()=>{
        navigate(AppRoutes.HOME, {replace: true});
    }

    function formatCurrency(value: string): string {
        // Convierte el string a número y luego formatea
        const number = parseFloat(value);
        if (isNaN(number)) {
          return "0.00"; // o cualquier valor por defecto que prefieras
        }
        return number.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    const hasIvaColumn = cuotas?.some((pago) => {
        const ivaName = pago.n_intnom_3?.trim().toLowerCase();
        const ivaValue = pago.n_int_3?.trim();
        return ivaName === 'iva' || (ivaValue !== '' && ivaValue !== undefined);
    });

    const headers = hasIvaColumn
        ? [...baseHeaders.slice(0, 4), { header: 'IVA' }, ...baseHeaders.slice(4)]
        : baseHeaders;

    return (
        <div className="pagos">
            <h3 className="redhead">De acuerdo con su solicitud las cuotas quedarían así:</h3>
            <div className="table">
                {/* <Table TableItem={Item} headers={headers} data={data} /> */}
                <table>
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index}>{header.header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {cuotas?.map((pago, index) => (
          <tr key={index}>
            <td>{pago.n_num_cuo}</td>
            <td>{pago.f_fecha}</td>
            <td>{formatCurrency(valorCuota)}</td>
            <td>{formatCurrency(pago.n_int_1)}</td>
            {hasIvaColumn && <td>{formatCurrency(pago.n_int_3 || '0')}</td>}
            <td>{formatCurrency(pago.n_capital)}</td>
            <td>{formatCurrency(pago.n_sal_fin)}</td>
          </tr>
        ))}
      </tbody>
    </table>

            </div>
            <div className="submit">
                <button type='button' className='botones' onClick={aceptar}>Continuar con el proceso</button>
            </div>
          {/*   <div className="submit">
                <button type='button' className='botones' onClick={finalizar}>Finalizar con el proceso</button>
            </div> */}
        </div>
    );
};
